function _call(callback) {
	if (!!callback && typeof callback === "function") {
		callback();
	}
}

export function whenConsented(key, onConsent, onDecline, forceConsent = false) {
	if ((!App.config.global.blockCookies && !forceConsent) || App.isShopBuilder) {
		_call(onConsent);
		return;
	}

	if (window.ConsentManager) {
		const consentManager = window.ConsentManager;
		const hasConsentResponse = consentManager.hasResponse();
		const hasKey = key !== "";
		const isKeyConsented = hasKey ? consentManager.isConsented(key) : false;

		if (hasConsentResponse || isKeyConsented) {
			if (!hasKey) {
				_call(onConsent);
			} else {
				_call(isKeyConsented ? onConsent : onDecline);
			}
		} else {
			document.addEventListener(
				"consent-change",
				() => {
					whenConsented(key, onConsent, onDecline);
				},
				{ once: true }
			);
		}
	} else {
		_call(onConsent);
	}
}
